import { useContext } from 'react';
import CartContext from '../context/cartContext';

export default () => useContext(CartContext)